module.exports = __webpack_public_path__ + "static/media/RS.eb3be364.svg";